import { useTranslation } from "react-i18next";
import styles from "./Skills.module.css";
import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import { ProgressBar } from "../../PresentationalComponents/ProgressBar";
import skills from "../../../assets/data/Skills";

const SkillsDictionary = {
  en: {
    sectionTitle: "SKILLS",
    sectionNum: "04",
    science: "Computer Science/Technologies",
    programingLanguages: "Programing Languages",
    platforms: "Platforms/Frame Works/Softwares",
    frontend: "Frontend",
  },
  fa: {
    sectionTitle: "مهارت‌ها",
    sectionNum: "۰۴",
    science: "علوم کامپیوتر/فناوری‌ها",
    programingLanguages: "زبان‌های برنامه نویسی",
    platforms: "پلتفرم‌ها/ برنامه‌های کاربردی/ فریم‌ورک‌ها",
    frontend: "فرانت اند",
  },
};

export function Skills({ t }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <section className={styles.sectionContainer} id="Skills">
      <div className={styles.header}>
        <SectionTitle
          text={SkillsDictionary[lang].sectionTitle}
          num={SkillsDictionary[lang].sectionNum}
        />
      </div>

      <div className={styles.skillSection}>
        <h3>{SkillsDictionary[lang].science} :</h3>
        <div className={styles.skillsContainer}>
          {skills[lang].map((skill, index) => {
            if (skill.category === "Science" || skill.category === "Topics") {
              return (
                <ProgressBar
                  text={skill.name}
                  percent={skill.percent}
                  lang={lang}
                />
              );
            } else return "";
          })}
        </div>
      </div>
      <div className={styles.skillSection}>
        <h3>{SkillsDictionary[lang].programingLanguages} :</h3>
        <div className={styles.skillsContainer}>
          {skills[lang].map((skill, index) => {
            if (skill.category === "Programing Language") {
              return (
                <ProgressBar
                  text={skill.name}
                  percent={skill.percent}
                  lang={lang}
                />
              );
            } else return "";
          })}
        </div>
      </div>
      <div className={styles.skillSection}>
        <h3>{SkillsDictionary[lang].frontend} :</h3>
        <div className={styles.skillsContainer}>
          {skills[lang].map((skill, index) => {
            if (skill.category === "Frontend") {
              return (
                <ProgressBar
                  text={skill.name}
                  percent={skill.percent}
                  lang={lang}
                />
              );
            } else return "";
          })}
        </div>
      </div>
      <div className={styles.skillSection}>
        <h3>{SkillsDictionary[lang].platforms} :</h3>
        <div className={styles.skillsContainer}>
          {skills[lang].map((skill, index) => {
            if (skill.category === "Platform") {
              return (
                <ProgressBar
                  text={skill.name}
                  percent={skill.percent}
                  lang={lang}
                />
              );
            } else return "";
          })}
        </div>
      </div>
    </section>
  );
}
